export const LIVE_CALL_SPEECH_INACTIVITY_MS = 40000;

export function createLiveCallInactivityController(options = {}) {
    const delayMs = Math.max(1000, Number(options.delayMs) || LIVE_CALL_SPEECH_INACTIVITY_MS);
    const onTimeout = typeof options.onTimeout === 'function' ? options.onTimeout : function() {};
    let timer = null;
    let active = false;

    function clearTimer() {
        if (timer) clearTimeout(timer);
        timer = null;
    }

    function schedule() {
        clearTimer();
        if (!active) return;
        timer = setTimeout(function() {
            timer = null;
            active = false;
            onTimeout();
        }, delayMs);
    }

    return {
        start: function() {
            active = true;
            schedule();
        },
        noteSpeech: function() {
            if (active) schedule();
        },
        pause: function() {
            active = false;
            clearTimer();
        },
        isActive: function() {
            return active;
        },
    };
}
